module.exports = __webpack_public_path__ + "assets/img/cloud1.7840356a.png";